// Root.jsx
import React, { useState, useEffect } from "react";
import { useOidc } from "@axa-fr/react-oidc";
import { useSelector } from "react-redux";
import FreshLogin from "./components/common/freshLogin";
import { Login } from "./pages/Login/LoginPage.jsx";
import App from "./App";

const Root = () => {
    const { isAuthenticated, login } = useOidc();
    const [initDone, setInitDone] = useState(false);
    const responseError = useSelector((state) => state.loginOn.responseError);

    // Handle initial login
    useEffect(() => {
        if (!isAuthenticated) {
            login(window.location.href);
        }
    }, [isAuthenticated]);

    // Handle token error -> re-login
    useEffect(() => {
        if (responseError) {
            login(window.location.href);
        }
    }, [responseError]);

    if (!isAuthenticated) return <Login />;
    if (!initDone) return <FreshLogin onComplete={() => setInitDone(true)} />;

    return <App />;
};

export default Root;
